import {connect} from 'react-redux';
import Form from './form';
import {specificAvailabilityCreatePerformed} from '../../../../../../actions/availability';

function mapsDispatchToProps (dispatch) {
    return {
        onAvailabilitySubmitted: (formData) => dispatch(specificAvailabilityCreatePerformed(formData))
    }
}

function mapsStateToProps (state) {
    return {
        loading: state.availability.is_loading,
        form_success: state.availability.form_success,
        errors: state.availability.specific_errors
    }
}

export default connect(() => (mapsStateToProps), mapsDispatchToProps)(Form);